import React from "react";
import VideoEmbed from "../ui/VideoEmbed";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import FadeIn from "../ui/FadeIn";

const SYT = () => (
  <PageLayout>
    <PageHero
      title="Don't Leave Your Special Talents At Home"
      subtitle="You've got talents, we've got opportunities"
      eyebrow="Share Your Talents"
      light
    />
    <section className="ku-section bg-white">
      <div className="ku-container">
        <div className="grid lg:grid-cols-2 gap-10 items-start">
          <FadeIn>
            <div className="ku-prose">
              <p>Your path to kindness is awaiting.</p>
              <p>
                At KU, we believe that everybody, yes, everybody has a speciality. A special talent that could help us in our mission of connecting & unifying people, by having them perpetually initiate acts of kindness, big or small.
              </p>
              <p>
                A special talent that perhaps you&apos;re so passionate about, you&apos;d not mind sharing it with the less privileged- for FREE!
              </p>
              <p>But, the question is:</p>
            </div>
            <div className="mt-6">
              <VideoEmbed src="https://www.youtube.com/embed/UpdxVuZwvDI" title="Dance for Kindness Mumbai 2014" />
            </div>
          </FadeIn>
          <FadeIn delay={0.1}>
            <VideoEmbed src="https://www.youtube.com/embed/BUyt7h5I9PM" title="Volunteers @Kindness Unlimited" />
            <div className="ku-prose mt-8">
              <h2 className="font-display text-2xl font-bold text-ku-royal">Are you ready to share your talents with the world?</h2>
              <p>
                If your answer is a loud YES IN RED, then dear kind soul, we invite you to read through the different kindness opportunities listed below.
              </p>
              <p>
                Whether a fresher or a veteran, a writer or a designer; <br />there&apos;re &apos;kindness opportunities&apos; for one & all!
              </p>
              <p>
                Inviting you to be a part of our kindness journey to share your talents & help us transform India into KINDia.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default SYT;
